import React from 'react';
import { Box, Fab, Stack, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import BoyIcon from '@mui/icons-material/Boy';
import { EventSlotsDraggableDialog } from './EventSlotsDraggableDialog';

export const ActionsControl = () => {
  const { module } = useSelector(state => state.app);
  const [showOptions, setShowOptions] = React.useState(false);
  const [showEventSlotsDialog, setShowEventSlotsDialog] = React.useState(false);

  if (module === 'zielone_szkoly' || module === 'rekrutacja' || module === 'wyjazdy_rodzinne') {
    return null;
  }

  return (
    <div>
      <Box sx={{ position: 'absolute', zIndex: 99999999, top: '20%', right: '1%' }}>
        <Stack direction="column" alignItems="center" justifyContent="center">
          <Fab color="success" onClick={() => setShowOptions(!showOptions)} size="medium" sx={{ mb: 1 }}>
            {showOptions ? <Tooltip title="Zwiń" placement="top" ><UpIcon /></Tooltip> : <Tooltip title="Rozwiń"><DownIcon /></Tooltip>}
          </Fab>
          {showOptions
            ? <Stack>
              <Tooltip title="Kontrola miejsc">
                <Fab color="info" size="small" onClick={() => setShowEventSlotsDialog(!showEventSlotsDialog)}>
                  <BoyIcon />
                </Fab>
              </Tooltip>
            </Stack>
            : null}
        </Stack>
      </Box>
      {showEventSlotsDialog ? <EventSlotsDraggableDialog onClose={() => setShowEventSlotsDialog(false)} /> : null}
    </div>

  );
};
